





































































import _ from 'lodash'
import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import { ApiGeneralSinglePayload, EditableResponse } from '@/tcw/api/types'
import { ShouninRouteResponse, ShouninStep } from '@/tcw/domain/types'
import * as ApiPath from '@/tcw/constant/ApiPath'
import { TCWBadDataStructureError } from '@/plugins/TCWBaseError'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import DataUpdateComponent from '@/tcw/components/DataUpdateComponent'
import ShouninRouteStep from '../molecules/ShouninRouteStep.vue'
import UserSelectDialog from '../molecules/UserSelectDialog.vue'

class ShouninRouteGetComponent extends DataGetComponent<EditableResponse<ShouninRouteResponse>> {}

@Component({
  components: { ShouninRouteStep, UserSelectDialog }
})
export default class ShouninRouteSteps extends Mixins(
  ShouninRouteGetComponent,
  DataUpdateComponent
) {
  @Prop({ type: Boolean, default: true })
  protected editMode!: boolean
  @Prop({ default: -1 })
  protected activeStep!: number
  @Prop({ default: false })
  protected isLock!: boolean

  @Emit('update:isLock')
  private updateIsLock(_isLock: boolean) {
    /** */
  }

  @Emit()
  private saveSuccess(): void {
    /** */
  }

  private dialogOpen = false
  private dialogStep: number | null = null
  private dialogNodeId: number | null = null
  private shouninRoute: ShouninStep[] = []
  private initialShouninRoute: ShouninStep[] = []

  get apiPath(): string {
    return ApiPath.Paths.ShouninRoute.get
  }

  public reset(): void {
    this.shouninRoute = _.cloneDeep(this.initialShouninRoute)
  }

  protected responseInitWebApi(response: EditableResponse<ShouninRouteResponse>): void {
    // ロック状態取得
    if (typeof response.lock === 'boolean') {
      this.updateIsLock(response.lock)
    }
    if (_.isArray(response.payload) || !_.isArray(response.payload.stepList)) {
      throw new TCWBadDataStructureError(
        'データ構造が不正です。システム管理者に問い合わせてください'
      )
    }
    this.shouninRoute = response.payload.stepList
    this.initialShouninRoute = _.cloneDeep(this.shouninRoute) // ← ここで初期状態を保持
  }

  get stepCount(): number {
    return this.shouninRoute.length
  }
  get nodeCount(): number {
    return this.shouninRoute.reduce((s, r) => {
      s += r.nodeList.length
      return s
    }, 0)
  }

  private addShouninsha(step: number): void {
    const targetStep = this.getShouninStep(step)
    if (targetStep) {
      targetStep.nodeList.push({
        nodeId: this.nodeCount + 1,
        shouninUserId: null,
        isHissuShouninUser: '0',
        maeNodeIdList: []
      })
    }
  }
  private removeShouninsha(step: number, nodeId: number): void {
    console.log(`remove: ${step}, ${nodeId}`)
    const targetStep = this.getShouninStep(step)
    if (targetStep) {
      targetStep.nodeList = targetStep.nodeList.filter(n => n.nodeId !== nodeId)
    }
  }
  private editShouninsha(step: number, nodeId: number): void {
    console.log(`edit: ${step}, ${nodeId}`)
    this.dialogOpen = true
    this.dialogStep = step
    this.dialogNodeId = nodeId
  }

  private getShouninStep(step: number): ShouninStep | undefined {
    return this.shouninRoute.find(r => r.shouninLevel === step)
  }

  private selectUser(userId: number, userInfo: ApiGeneralSinglePayload): void {
    console.log(`ユーザ選択: ${userId}`, userInfo)
    const targetStep = this.shouninRoute.find(r => r.shouninLevel === this.dialogStep)
    if (targetStep) {
      const targetNode = targetStep.nodeList.find(n => n.nodeId === this.dialogNodeId)
      if (targetNode) {
        targetNode.shouninUserId = userId
        this.$set(targetNode, 'shouninUserInfo', userInfo)
      } else {
        console.error(
          `対象のノードがみつかりません。ステップ：${this.dialogStep}、ノード：${this.dialogNodeId}`
        )
      }
    } else {
      console.error(
        `対象のステップがみつかりません。ステップ：${this.dialogStep}、ノード：${this.dialogNodeId}`
      )
    }
    console.log(this.shouninRoute)
    this.dialogOpen = false
    this.dialogStep = null
    this.dialogNodeId = null
  }
  private closeDialog(): void {
    this.dialogOpen = false
  }

  private isFirstStep(step: number): boolean {
    return step === 0
  }

  private isLastStep(step: number): boolean {
    return step === this.shouninRoute.length - 1
  }

  private createStepTitle(step: number): string {
    if (this.isFirstStep(step)) {
      // 最初
      return '提出時'
    } else if (this.isLastStep(step)) {
      // 最終
      return '最終承認'
    } else {
      // 途中
      return `承認ステップ${step}`
    }
  }

  private addStep(step: number): void {
    if (this.shouninRoute.length > 11) {
      this.$tcw.message({
        type: 'danger',
        message: 'ステップはこれ以上を増やせません'
      })
      return
    }
    let src = this.shouninRoute.find(r => r.shouninLevel === step)
    src = _.cloneDeep(src)
    if (src) {
      src.nodeList = []
      const idx = this.shouninRoute.findIndex(r => r.shouninLevel === step)
      this.shouninRoute.splice(idx + 1, 0, src)
    }
    // 承認レベルの再設定
    this.shouninRoute.forEach((r, i) => (r.shouninLevel = i))

    // １行追加
    this.addShouninsha(step + 1)
  }
  private removeStep(step: number): void {
    this.shouninRoute = this.shouninRoute.filter(r => r.shouninLevel !== step)

    // 承認レベルの再設定
    this.shouninRoute.forEach((r, i) => (r.shouninLevel = i))
  }

  protected async beforeSaveProc(): Promise<void> {
    // ノードIDの貼り直し
    let nodeId = 1
    let maeNodeIdList: number[] = [] // 前ノードIDリスト
    this.shouninRoute.forEach((r, i, ary) => {
      if (i > 0) {
        const maeNodeList = ary[i - 1].nodeList
        maeNodeIdList = maeNodeList.map(n => n.nodeId as number)
      }
      r.nodeList.forEach(n => {
        n.nodeId = nodeId++
        n.maeNodeIdList = maeNodeIdList
      })
    })

    console.log('保存前にノードID振り直し', this.shouninRoute)
  }

  protected async execSaveMain(): Promise<void> {
    // API 構築
    const apiPath = ApiPath.Paths.ShouninRoute.put
    const stepList = (this.shouninRoute as unknown) as ApiGeneralSinglePayload
    await this.getWebApi().call(apiPath, 'PUT', { stepList })
  }

  protected async afterSaveProc(): Promise<void> {
    this.$tcw.message({
      type: 'success',
      message: '承認ルートを更新しました'
    })
    this.serverCheckInfo = Object.assign(this.serverCheckInfo, {})
    // 保存成功後に初期状態も更新
    this.initialShouninRoute = _.cloneDeep(this.shouninRoute)
    this.saveSuccess()
  }
}
